// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-list .v-list-item__subtitle[data-v-1283fc8c],.v-list-item__title[data-v-1283fc8c]{white-space:normal}.avatar-link[data-v-1283fc8c]{height:40px;width:40px}.link[data-v-1283fc8c]{cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
